module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAVdJREFUOBGNlL1KA1EQhRPxJyCICgGxCzaWBksbCT5DahsLCwMiVuIrCNZWonZiJYJg5xsYsBIiiBGEgCgKCer6je7A3NmbjRcOc87MmbObbDaFgjtJkoyANXAJnsAHaIFjsOLscYmxCu5A3jlnOBVPoMtwEbznJZhZEz6RCaNZAvfGqLQHeVDh6mEsqOFMXfQmGBUztQyOgD3fiPkgjMa1dcC3A8NfWJH+lfPtBD6GHWOQK00GhlTQrxuf0BP1DaXk9yOkvEd9U4OrHaeHVWvQjTaoY2DJaEtrVsCbgeYW190t36JnrQm9DOQh6PmCzFmPPJVx0FZHWl+oB2AXnAH57uw5DUJU4Fi1rgFcfrgV3c1UhhcDAnS8lVm2DVwz4FndfapcrGj3ohxTDXz2CWnRn44uxpqYNyJBr/QWYv7cHkt7Jkxe3v/9F/lUFuXd2gePoO7nXv8A4j57vcvko+YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/place.png
// module id = wtJD
// module chunks = 1